import { render, staticRenderFns } from "./complianceReport.vue?vue&type=template&id=1a58c658&scoped=true&lang=en&"
import script from "./complianceReport.vue?vue&type=script&lang=js&"
export * from "./complianceReport.vue?vue&type=script&lang=js&"
import style0 from "./complianceReport.vue?vue&type=style&index=0&id=1a58c658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a58c658",
  null
  
)

export default component.exports